<template>
  <div class="page404 noPadding">
    <p class="page404_p0">所在食堂已过期，请联系代理商开通/续费！</p>
    <router-link to="/logout">
      <a-button @click="logOut">退出</a-button>
    </router-link>
  </div>
</template>

<script>
import {
  logout,
} from "@/request/api";
export default {
  data() {
    return {
      
    };
  },
  name: "Tips",
  mounted() {
    
  },
  components: {
    
  },
  created() {
    
  },
  computed: {
   
  },
  methods: {
    logOut() {
      logout().then(res=>{
        this.$store.commit("REMOVE_COUNT");
      })
    },
  },
};
</script>
<style scoped lang="less">
.page404 {
  width: 100%;
  height: 100%;
  text-align: center;
  background: #b5c794 url(../../assets/404img/img-404.png) no-repeat center
    center !important;
  .page404_p0 {
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding: 80px 0 20px 0;
  }
}
</style>
